// src/config/permissions.js

export const SUPER_ADMIN_EMAILS = [
  "codycuthill@easapp.ca"
];

export const isSuperAdmin = (user) => {
  return user && user.email && SUPER_ADMIN_EMAILS.includes(user.email.toLowerCase());
};